import {Store} from "pullstate";
import _ from "../../src/_/index";
import {AuthStore, saveOfflineAuth} from "./Common_Store";

export const Pg_0_1_Store = new Store({});
export const Pg_0_2_Store = new Store({});
export const Pg_0_3_Store = new Store({});
export const Pg_0_4_Store = new Store({});
export const Pg_0_5_Store = new Store({});
export const Pg_0_18_Store = new Store({});
export const Pg_0_19_Store = new Store({});
export const Pg_0_20_Store = new Store({});
export const Pg_0_22_Store = new Store({});
let fetchOption = (postParams) => {

    return {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
        headers: {
            'Content-Type': 'application/json'
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify(postParams) // body data type must match "Content-Type" header
    } as any;
};

export const fetch_pg_0_1 = async (contractId) => {
    let postParams = {
        p1: contractId,
    };
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/pg_0_1`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        Pg_0_1_Store.update(s => {
            return Object.assign(s, payload)
        });

    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    // await data.filter((quote, index) => {
    //     quote.id = (Date.now() + index);
    //     quote.image = `https://source.unsplash.com/random/1200x400?sig=${ quote.id }`;
    // });
}
export const fetch_pg_0_2 = async (postParams: {}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/pg_0_2`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        Pg_0_2_Store.update(s => {
            return Object.assign(s, payload)
        });
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }
}

export const fetch_pg_0_3 = async (postParams: {}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/pg_0_3`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        Pg_0_3_Store.update(s => {
            return Object.assign(s, payload)
        });
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }
}

export const fetch_pg_0_4 = async (postParams: {}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/pg_0_4`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        Pg_0_4_Store.update(s => {
            return Object.assign(s, payload)
        });

    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    // await data.filter((quote, index) => {
    //     quote.id = (Date.now() + index);
    //     quote.image = `https://source.unsplash.com/random/1200x400?sig=${ quote.id }`;
    // });
}
export const fetch_pg_0_5 = async (postParams: {}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/pg_0_5`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        Pg_0_5_Store.update(s => {
            return Object.assign(s, payload)
        });

    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    // await data.filter((quote, index) => {
    //     quote.id = (Date.now() + index);
    //     quote.image = `https://source.unsplash.com/random/1200x400?sig=${ quote.id }`;
    // });
}
export const fetch_pg_0_18 = async (postParams: {}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/pg_0_18`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        Pg_0_18_Store.update(s => {
            return Object.assign(s, payload)
        });

    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    // await data.filter((quote, index) => {
    //     quote.id = (Date.now() + index);
    //     quote.image = `https://source.unsplash.com/random/1200x400?sig=${ quote.id }`;
    // });
}
export const fetch_pg_0_19 = async (postParams: {}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/pg_0_19`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        Pg_0_19_Store.update(s => {
            return Object.assign(s, payload)
        });

    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }
}
export const fetch_pg_0_20 = async (postParams: {}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/pg_0_20`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        Pg_0_20_Store.update(s => {
            return Object.assign(s, payload)
        });

    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }
}

export const fetch_pg_0_22 = async (postParams: {}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/pg_0_22`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        Pg_0_22_Store.update(s => {
            return Object.assign(s, payload)
        });

    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }
}

export const push_pg_0_3 = async (postParams: {
    scodeEmail: string,
    vcodeEmail: string,
    scodePhone: string,
    vcodePhone: string,
    電子郵件: string,
    手機號碼: string,
    手機國碼: string,
    登入密碼: string,
    個人介紹: string,
    個人照片: string,
    寄送地址_收件人: string,
    寄送地址_連絡電話: string,
    寄送地址_收件地址: string,
    暱稱: string,
}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/_pg_0_3`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        // Pg_3_11_Store.update(s => {
        //     let o: any = s;
        //     Object.assign(o, payload);
        //     o._pg_3_1 = payload;
        //     return o;
        // });

        AuthStore.update(s => {
            let _s: any = s;
            Object.assign(_s, payload);
            Object.assign(_s, {signBy: 'push_pg_A_1'})
            //o._pg_A_1 = payload;
            return _s;
        });
        await saveOfflineAuth();


        return result;
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    return false;
}


export const push_pg_0_4 = async (postParams: {
    p1: string,
}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/_pg_0_4`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        // Pg_3_11_Store.update(s => {
        //     let o: any = s;
        //     Object.assign(o, payload);
        //     o._pg_3_1 = payload;
        //     return o;
        // });

        return result;
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    return false;
}


export const push_pg_0_5 = async (postParams: {
    p1: string,
}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/_pg_0_5`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        // Pg_3_11_Store.update(s => {
        //     let o: any = s;
        //     Object.assign(o, payload);
        //     o._pg_3_1 = payload;
        //     return o;
        // });

        return result;
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    return false;
}
